<template>
    <div class="login-form d-flex align-items-center">
        <form class="sign-in-sign-up-form w-100" ref="form" data-url="admin/users/login" >
          <a class="navbar-brand brand-logo mb-4" href="#" style="height: 150px;width: 100%" >
            <img :src="logoUrl" alt="logo"/>
          </a>
            <div class="form-row">
                <div class="form-group col-12">
                    <h6 class="text-center mb-0">{{ $t('hi', {object: $t('there')}) }}!</h6>
                    <label class="text-center d-block">{{ $t('login_to_your_dashboard') }}</label>
                </div>
            </div>

            <app-form-group
                    :label="$t('email')"
                    type="email"
                    v-model="formData.email"
                    :placeholder="$placeholder('your', 'email')"
                    :error-message="$errorMessage(errors, 'email')"
            />

            <app-form-group
                    :label="$t('password')"
                    type="password"
                    v-model="formData.password"
                    :placeholder="$placeholder('your', 'password')"
                    :error-message="$errorMessage(errors, 'password')"
                    :show-password="true"
            />

            <div class="form-row">
                <div class="form-group col-12">
                    <app-submit-button
                        btn-class="d-inline-flex btn-block text-center btn-primary"
                        :label="$t('login')"
                        :loading="loading"
                        @click="submitData"
                    />
                </div>
            </div>

            <div class="form-row">
                <div class="col-6">
                    <app-input
                        class="mb-primary"
                        type="single-checkbox"
                        :list-value-field="$t('remember_me')"
                        v-model="formData.remember_me"
                    />
                </div>

                <div class="col-6 text-right">
                    <a :href="urlGenerator('/users/password-reset')" class="bluish-text">
                        <i data-feather="lock" class="pr-2"/>{{ $t('forget', {subject: $t('password')}) }}?
                    </a>
                </div>
            </div>

            <div class="form-group">
                <div class="col-12">
                    <p class="text-center mt-5 footer-copy">
                        {{ $t('copyright') }} @ {{ new Date().getFullYear() }} {{ $t('by') }} {{ appName }}
                    </p>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import ThemeMixin from "../../Mixin/Global/ThemeMixin";
    import FormHelperMixins from "../../Mixin/Global/FormHelperMixins";

    export default {
        name: "Login",
        mixins: [ThemeMixin, FormHelperMixins],
        props: {
            logoUrl: {
                required: false
            },
            appName: {
                required: false
            },
            previousPage: {
                required: false
            },
            demo: {}
        },
        data() {
            return {
                loginRole: ''
            }
        },
        methods: {
            submitData() {
                this.message = '';
                this.loading = true;
                this.save(this.formData);
            },

            afterSuccess({ data }) {
                window.location.href = data;
            },
            afterFinalResponse(){},
        },
        computed: {
            demoCredentials(){
                return this.demo ? JSON.parse(this.demo) : '';
            },
            selectableRole(){
                return [{ id: '', name: this.$t('select_role') }]
                    .concat(Object.keys(this.demoCredentials).map((item) => {
                        return {
                            id: item,
                            name: this.demoCredentials[item].role,
                        }
                    }))
            },
            loginRoleUpdate(){
                return this.loginRole
            }
        },
        watch: {
            // loginRoleUpdate: {
            //     handler: function (role){
            //         this.formData.password = role ? this.demoCredentials[role].password : '';
            //         this.formData.email = role ? this.demoCredentials[role].email: '';
            //     }
            // }
        }

    }
</script>

<style scoped>
/* Full screen background */
.login-form {
    min-height: 100vh;
    background: linear-gradient(135deg, #4f46e5, #06b6d4);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

/* Login card */
.sign-in-sign-up-form {
    background: #fff;
    padding: 2.5rem;
    border-radius: 16px;
    box-shadow: 0px 15px 35px rgba(0, 0, 0, 0.15);
    max-width: 420px;
    width: 100%;
    animation: fadeIn 0.6s ease-in-out;
    position: relative;
    overflow: hidden;
}

/* Subtle shine effect on card */
.sign-in-sign-up-form::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(120deg, rgba(255,255,255,0.15), transparent 70%);
    transform: rotate(25deg);
    pointer-events: none;
}

/* Logo styling */
.logo {
    max-width: 300px;
    margin-bottom: 15px;
    transition: transform 0.3s ease;
}
.logo:hover {
    transform: scale(1.05);
}

/* Typography */
h6 {
    font-size: 1.3rem;
    font-weight: 700;
    color: #333;
}
label {
    font-size: 0.9rem;
    color: #555;
}

/* Inputs */
input, select {
    width: 100%;
    padding: 12px 14px;
    border-radius: 10px;
    border: 1px solid #ccc;
    margin-bottom: 15px;
    font-size: 0.95rem;
    outline: none;
    transition: all 0.3s ease;
    background-color: #f9f9f9;
}
input:focus, select:focus {
    border-color: #4f46e5;
    background-color: #fff;
    box-shadow: 0 0 8px rgba(79, 70, 229, 0.3);
}

/* Button */
.btn-primary {
    background: linear-gradient(135deg, #4f46e5, #06b6d4);
    color: #fff;
    border: none;
    padding: 12px;
    font-size: 1rem;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 600;
    box-shadow: 0 4px 10px rgba(79, 70, 229, 0.3);
}
.btn-primary:hover {
    background: linear-gradient(135deg, #06b6d4, #4f46e5);
    box-shadow: 0 6px 15px rgba(79, 70, 229, 0.4);
    transform: translateY(-2px);
}

/* Links */
.bluish-text {
    color: #4f46e5;
    font-size: 0.85rem;
    text-decoration: none;
    transition: color 0.3s ease;
}
.bluish-text:hover {
    color: #06b6d4;
}

/* Footer text */
.footer-copy {
    font-size: 0.8rem;
    color: #888;
}

/* Animation */
@keyframes fadeIn {
    from { opacity: 0; transform: translateY(15px); }
    to { opacity: 1; transform: translateY(0); }
}
</style>


